import { render, staticRenderFns } from "./BaseTableExcelExporter.vue?vue&type=template&id=3ef07bce&scoped=true&"
import script from "./BaseTableExcelExporter.vue?vue&type=script&lang=js&"
export * from "./BaseTableExcelExporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef07bce",
  null
  
)

export default component.exports